module.exports = __webpack_public_path__ + "static/img/resume-side-bar-projects.71772e6.png";